export const ANALYTICS = {
  LOAD_TIME: 'LOAD_TIME',
  CLICK: 'CLICK',
  GW_LOGGER_INSTANCE: 'GW_LOGGER_INSTANCE'
};

export const COMPONENT_NAME = {
  TIMELINE: 'TIMELINE',
  STATIC_TIMELINE: 'STATIC TIMELINE',
  REPORT_ACCORDION: 'REPORT ACCORDION',
  REPAIRS_ACCORDION: 'REPAIRS ACCORDION',
  PAYOUT_ACCORDION: 'PAYOUT ACCORDION',
  SERVICES_ACCORDION: 'SERVICES ACCORDION',
  CLOSE_ACCORDION: 'CLOSE ACCORDION',
  ALL_FAQS: 'ALL FAQS',
  INTERACTIVE_FAQS: 'INTERACTIVE FAQS',
  CLAIM_SUMMARY: 'CLAIM SUMMARY',
  CLAIM_LIST: 'CLAIM LIST',
  CONTACT_US: 'CONTACT US',
  TOGGLE: 'TOGGLE',
  ASSOCIATE_COMMS_LOG: 'ASSOCIATE COMMS LOG',
  SEARCH_BAR: 'SEARCH BAR'
};

export const REPAIR_SHOP_API_ENDPOINTS = {
  SEARCH_URL: '/repair-facilities/search-v2',
  TYPE_AHEAD_URL: '/product-pricing/locationlookup/v1/suggests',
  CREATE_ENTEGRAL_CLAIM_URL: '/repair-facilities/create-entegral-claim-id',
  ENTEGRAL_DEFAULT_CLIENT_NETWORK_KEY: '15f7ef7e-5cf8-4aa9-9673-a61c7ff4a255',
  VEHICLE_MAKES_URL: '/underwritingmanagement/vehicleinquiry_1/v1/vehicleModelMakes',
  VEHICLE_MODELS_URL: '/underwritingmanagement/vehicleinquiry_1/v1/vehicleModels'
};

// eslint-disable-next-line no-template-curly-in-string
export const API_BASE_URL = 'https://api-${env}.nwie.net';
// eslint-disable-next-line claims/no-hardcoded-nw-url
export const API_TEST_BASE_URL = 'https://api-test.nationwide.com';
// eslint-disable-next-line claims/no-hardcoded-nw-url
export const API_PROD_BASE_URL = 'https://api.nationwide.com';
// eslint-disable-next-line claims/no-hardcoded-nw-url
export const API_BREAKFIX_BASE_URL = 'https://api-int-stage.nwie.net';
// eslint-disable-next-line claims/no-hardcoded-nw-url
export const API_STAGE_BASE_URL = 'https://api-stage.nationwide.com';

export const BASE_URL_MAPPING: { [key: string]: string } = {
  prod: API_PROD_BASE_URL,
  breakfix: API_BREAKFIX_BASE_URL,
  pt: API_STAGE_BASE_URL,
  stage: API_STAGE_BASE_URL,
  trnm: API_TEST_BASE_URL,
  trn: API_TEST_BASE_URL
};
